import { graphql, Link, useStaticQuery } from "gatsby"
import { getImage } from "gatsby-plugin-image"
import { GatsbyImage } from "gatsby-plugin-image"
import React from "react"
import { Col, Container, Row } from "react-bootstrap"

const query = graphql`
  {
    allStrapiBlogs(
      limit: 3
      sort: { fields: published_at, order: DESC }
      filter: { isFeatured: { eq: true } }
    ) {
      nodes {
        id
        slug
        title
        shortDescription
        category
        Image {
          localFile {
            childImageSharp {
              gatsbyImageData(placeholder: BLURRED)
            }
          }
        }
      }
    }
  }
`

const FeaturedPosts = () => {
  const data = useStaticQuery(query)
  const {
    allStrapiBlogs: { nodes: featuredPosts },
  } = data

  const path1 = getImage(featuredPosts[0]?.Image.localFile)
  const path2 = getImage(featuredPosts[1]?.Image.localFile)
  const path3 = getImage(featuredPosts[2]?.Image.localFile)

  return (
    <Container className="featured-posts">
      <div>
        <h1 className="rb b-h">Featured Posts</h1>
      </div>
      <Row className="justify-content-center my-3 my-lg-5">
        <Col md={12} lg={6}>
          <Link
            to={`/blog/${featuredPosts[0]?.category}/${featuredPosts[0]?.slug}`}
          >
            <GatsbyImage
              image={path1}
              alt={featuredPosts[0]?.title}
              className="m-img"
            />
          </Link>
          <Link to={`/blog/${featuredPosts[0]?.category}`}>
            <p className="my-2 cat">{featuredPosts[0]?.category}</p>
          </Link>
          <Link
            to={`/blog/${featuredPosts[0]?.category}/${featuredPosts[0]?.slug}`}
          >
            <h1 className="rb b-h">{featuredPosts[0]?.title}</h1>
            <p className="width-more">{featuredPosts[0]?.shortDescription}</p>
          </Link>
        </Col>
        <Col md={12} lg={6}>
          <div className="my-flex small-grid">
            <div className="f-subp">
              <Link
                to={`/blog/${featuredPosts[1]?.category}/${featuredPosts[1]?.slug}`}
              >
                <GatsbyImage image={path2} alt={featuredPosts[1]?.title} />
              </Link>
              <Link to={`/blog/${featuredPosts[1]?.category}`}>
                <p className="my-2 cat">{featuredPosts[1]?.category}</p>
              </Link>
              <Link
                to={`/blog/${featuredPosts[1]?.category}/${featuredPosts[1]?.slug}`}
              >
                <h1 className="rb">{featuredPosts[1]?.title} </h1>
              </Link>
            </div>
            <div className="f-subp my-lg-4">
              <Link
                to={`/blog/${featuredPosts[2]?.category}/${featuredPosts[2]?.slug}`}
              >
                <GatsbyImage image={path3} alt={featuredPosts[2]?.title} />
              </Link>
              <Link to={`/blog/${featuredPosts[2]?.category}`}>
                <p className="my-2 cat">{featuredPosts[2]?.category}</p>
              </Link>
              <Link
                to={`/blog/${featuredPosts[2]?.category}/${featuredPosts[1]?.slug}`}
              >
                <h1 className="rb">{featuredPosts[2]?.title} </h1>
              </Link>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  )
}

export default FeaturedPosts
